module.exports = __webpack_public_path__ + "img/d20190727_6.601ae61f.jpg";